import { AuthProvider } from '../userProfile/userProfileTypes'
import {
  inviteUsersIdentityService,
  postAddNewPartnerData,
  postAddUsersData,
} from '../../api/users'
import { AddUserRequestSuccess } from '../../utils/messagesContants'
import type { UserType } from './reducer'

export const submitUserInvitations = async ({
  data,
  partnerId,
  authProvider,
  isAdmin,
}: {
  data: UserType[]
  partnerId: string
  authProvider: `${AuthProvider}`
  isAdmin: boolean
}) => {
  const invitationData = {
    users: data,
  }
  if (isAdmin) {
    await postAddNewPartnerData(invitationData)
    return
  }
  if (authProvider == AuthProvider.AUTH0) {
    await inviteUsersIdentityService(invitationData, partnerId)
  } else {
    await postAddUsersData(invitationData, partnerId)
  }
}

export const getAddUserSuccessMessage = (data: UserType[]) =>
  data.length === 1
    ? `Invitation sent succesfully to "${data[0].email}".`
    : AddUserRequestSuccess
